/*
 * Copyright (c) 2024 CalAmp Corp. All Rights Reserved
 */
import {Page} from '@ion/applications/src/types/pages';
import pages from '../pages';

/**
 * @authorizedPages
 *
 * Provides a utility which traverses all page definitions are returns only the
 * pages to which the user is authorized access.
 */
export const authorizedPages = (pages: Page[] = []): Page[] => (
  pages?.map(page => {
    const {pages, isAuthorized} = page;
    if (isAuthorized) {
      if (!pages?.length) {
        return page;
      }
      const authorizedPage = {...page};
      authorizedPage.pages = authorizedPages(pages);
      return authorizedPage;
    };
  }).filter(page => page) ||
  []
);
